import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const Message = styled.div`
  font-family: 'Open Sans';
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray900};
  margin-bottom: ${rem(56)};
`;

export const Buttons = styled.div`
  display: flex;
  gap: ${rem(8)};
  justify-content: flex-end;

  button {
    margin: 0;
    flex-grow: 0.1;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    flex-direction: column;
    gap: ${rem(16)};

    button {
      width: 100%;
    }
  }
`;

export const LineSeparator = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray600};
  padding-bottom: ${rem(16)};
`;